import { Dropdown } from 'antd';
import styled from 'styled-components';

export const AntDropdown = styled(Dropdown)``;
